module.exports = __webpack_public_path__ + "static/Mobile_2@2x-fcdcda96a300e068c9acf5b9c6dbcb0f.png";